const identify = (jwt) => {
    if (process.env.ENVIRONMENT_NAME === "prod" && window.gtag) {
        window.gtag("set", { user_id: jwt.sub });
    }
};

export default identify;
